export const RESET_HISTORY = 'RESET_HISTORY';
export const UPDATE_HISTORY = 'UPDATE_HISTORY';
export const DATA_FETCHING = 'DATA_FETCHING';
export const SET_DATA_TYPE = 'SET_DATA_TYPE';
export const ADD_HISTORY = 'ADD_HISTORY';
export const SET_FETCHING_ERROR = 'SET_FETCHING_ERROR';
